import React from 'react'
import _ from 'underscore'
import { UserPlus } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { DropdownMenu } from '../dropdown_menu'
import ProfilePicture from '../profile_pictures/show'

class TaskAssignee extends React.Component {

  onChange = (assignee) => {
    this.props.onChange(assignee)
  }

  render() {
    const { assignee, team } = this.props

    const assigneeOptions = _.map(this.props.assignees, (assignee) => {
      return {
        value: assignee,
        name: assignee.name
      }
    })

    let title = "Unassigned"

    if (assignee && team) {
      title = `Assigned to ${assignee.name} on ${team} team`
    }
    else if (assignee) {
      title = `Assigned to ${assignee.name}`
    }
    else if (team) {
      title = `Assigned to ${team} team`
    }

    return (
      <DropdownMenu searchable buttonClassName="btn btn-link p-0" className="dropdown-menu dropdown-menu-right" name='Assign' items={assigneeOptions} onItemClick={this.onChange}>
        {assignee ?
          <ProfilePicture
            className="size-[30px] rounded-full object-cover"
            id={assignee.id}
            profile_picture={assignee.profile_picture}
            width="30px"
            title={title}
          />
          : null
        }
        {(!assignee && team) ?
          <Badge variant="secondary" className="h-[30px] rounded-full border-0 uppercase" title={title}>
            {team}
          </Badge>
          : null
        }
        {(!assignee && !team) ?
          <span className="inline-flex size-[30px] items-center justify-center rounded-full bg-muted text-muted-foreground" title={title}>
            <UserPlus className="size-4"/>
          </span>
          : null
        }
      </DropdownMenu>
    )
  }
}

export default TaskAssignee
